var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-display"},[(_vm.label)?_c('label',{class:_vm.labelClass},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"position-relative"},[_c('label',[_vm._v(_vm._s((_vm.value != undefined && _vm.value != null && _vm.value != '') ? _vm.formatedText : _vm.emptyText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }